import { render, staticRenderFns } from "./AcquisitionDocumentsPage.vue?vue&type=template&id=c9199a3a&scoped=true"
import script from "./AcquisitionDocumentsPage.vue?vue&type=script&lang=js"
export * from "./AcquisitionDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./AcquisitionDocumentsPage.vue?vue&type=style&index=0&id=c9199a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9199a3a",
  null
  
)

export default component.exports